<template>
    <div class="specs-container m-t-md">
        <div class="specs-container--list">
            <ol class="list-none">
                <template v-if="['PC Only', 'Essential Bundle'].includes(build.name)">
                    <li class="text-upper text-bold">
                        {{ parts.cases.name }} {{ parts.cases.quantity > 1 ? `(${parts.cases.quantity})`: '' }}
                        <span class="text-sm text-normal">CASE</span>
                    </li>
                    <li class="text-upper text-bold">
                        {{ parts.motherboards.name }} {{ parts.motherboards.quantity > 1 ? `(${parts.motherboards.quantity})`: '' }}
                        <span class="text-sm text-normal">MOBO</span>
                    </li>
                    <li class="text-upper text-bold">
                        {{ parts.gpus.name }} {{ parts.gpus.quantity > 1 ? `(${parts.gpus.quantity})`: '' }}
                        <span class="text-sm text-normal">GPU</span>
                    </li>
                    <li class="text-upper text-bold">
                        {{ parts.cpus.name }} {{ parts.cpus.quantity > 1 ? `(${parts.cpus.quantity})`: '' }}
                        <span class="text-sm text-normal">CPU</span>
                    </li>
                    <li class="text-upper text-bold">
                        {{ parts.coolers.name }} {{ parts.coolers.quantity > 1 ? `(${parts.coolers.quantity})`: '' }}
                        <span class="text-sm text-normal">CPU COOLER</span>
                    </li>
                    <li class="text-upper text-bold">
                        {{ parts.ram.name }} {{ parts.ram.quantity > 1 ? `(${parts.ram.quantity})`: '' }}
                        <span class="text-sm text-normal">RAM</span>
                    </li>
                </template>
                <template v-else>
                    <li class="text-upper text-bold">
                        NZXT STREAMING BUILD
                        <span class="text-sm text-normal">PC</span>
                    </li>
                    <li v-for="extra in firstColumExtras" class="text-upper text-bold text-green" :key="'extra1-' + extra.id">
                        {{ extra.name }} {{ extra.quantity > 1 ? `(${extra.quantity})`: '' }}
                        <span class="text-sm text-normal text-uppercase">{{ extra.model_label }}</span>
                    </li>
                </template>
            </ol>
        </div>

        <div class="specs-container--list">
            <ol class="list-none">
                <template v-if="['PC Only', 'Essential Bundle'].includes(build.name)">
                    <li class="text-upper text-bold" v-for="(disk, index) in parts.storage" :key="'ssd-' + index">
                        {{ disk[144].name }}
                        <template v-if="disk[144].quantity > 1">
                            ({{ disk[144].quantity }})
                        </template>
                        <span class="text-sm text-normal text-uppercase">SSD</span>
                    </li>
                    <li class="text-upper text-bold">
                        {{ parts.psus.name }}
                        <span class="text-sm text-normal text-uppercase">PSU</span>
                    </li>
                </template>
                <li v-for="extra in realSecondColumExtras" class="text-upper text-bold text-green" :key="'extra2-' + extra.id">
                    {{ extra.name }} {{ extra.quantity > 1 ? `(${extra.quantity})`: '' }}
                    <span class="text-sm text-normal text-uppercase">{{ extra.model_label }}</span>
                </li>
            </ol>
        </div>
    </div>
</template>

<script>
import _concat from "lodash/concat";
import _cloneDeep from "lodash/cloneDeep";

export default {
    name: "BuildSpecs",

    props: {
        build: {
            type: Object,
            required: true
        }
    },
    computed: {
        parts() {
            return _cloneDeep(this.build.parts);
        },
        allExtras() {
            const bundles = _cloneDeep(this.build.parts.bundles) || [];
            let allExtras = _cloneDeep(this.build.parts.extras) || [];

            bundles.forEach(bundle => {
                allExtras = _concat(allExtras, bundle.items);
            });

            return allExtras;
        },
        firstColumExtras() {
            return this.allExtras.slice(0, 5);
        },
        secondColumExtras() {
            return this.allExtras.slice(5);
        },
        realSecondColumExtras() {
            if (!this.firstColumExtras.length) {
                return [];
            } else if (this.firstColumExtras.length && !this.secondColumExtras.length) {
                return this.firstColumExtras;
            } else {
                return this.secondColumExtras;
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    .specs-container {
        display: flex;
        flex-flow: row wrap;
        justify-content: space-between;
        align-items: flex-start;

        &--list {
            width: 45%;

            ol {
                li {
                    font-size: 18px;
                    letter-spacing: 0.46px;
                    line-height: 22px;
                    margin-bottom: 18px;

                    span {
                        letter-spacing: 0.36px;
                        color: #000;
                    }
                }
            }
        }
    }
    @media screen and  (max-width: 990px) and (min-width: 320px) {
        .specs-container {
            &--list {
                width: 100%;

                ol {
                    li {
                        font-size: 15px;
                    }
                }
            }
        }
    }
</style>
